<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="活动名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入标签名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="最近编辑时间" prop="updatedTimeStart">
                        <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" :loading="exporting" @click="options('add')" size="small"
                        icon="el-icon-plus">新增活动类型</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog :title="statusTitle" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left" v-if="statusTitle == '禁用信息'">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    当前活动已经【启用】，是否确认禁用该活动？
                </div>
                <div class="info" style="text-align: left" v-else>
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    当前活动已经【禁用】，是否确认启用该活动？
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isS = false">取消</div>
                    <div class="info-s" @click="submitA">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog :title="optionsActivity" :append-to-body="true" :close-on-click-modal="false"
            :visible.sync="dialogActivity" width="518px">
            <el-form ref="form" label-width="80px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form">
                <el-form-item label="活动名称" prop="name">
                    <el-input placeholder="请输入活动名称" v-model="form.name" style="width: 100%" maxlength="10"
                        show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="订单类型" prop="orderType">
                    <el-input placeholder="请输入订单类型" v-model="form.orderType" style="width: 100%" maxlength="6"
                        :disabled="optionsActivity == '编辑活动'" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="页面图" prop="image">
                    <upload-picture :imageUrl="form.image" :width="'108px'" :height="'108px'"
                        @getUrl="getImage($event, 'image')"></upload-picture>

                </el-form-item>
                <el-form-item>
                    <div class="p-info">图片尺寸：建议上传750px*400px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                </el-form-item>
                <el-form-item label="筛选标签" prop="tag">
                    <el-cascader style="width: 100%" :options="tagIds1" v-model="tag" placeholder="请选择筛选标签" ref="cascader"
                        :props="{ checkStrictly: false, multiple: true, emitPath: false }" clearable></el-cascader>
                </el-form-item>
                <el-form-item label="展示标签" prop="tagStore">
                    <el-cascader style="width: 100%" :options="tagIdsShow1" v-model="tagStore" placeholder="请选择展示标签"
                        :props="{ checkStrictly: false, multiple: true, emitPath: false }" clearable></el-cascader>
                </el-form-item>
                <el-form-item label="营销标签" prop="tagMarketing">
                    <el-select style="width: 100%" v-model="tagMarketing" placeholder="请选择标签（可多选）" ref="refTag" multiple>
                        <el-option v-for="item in tagMarketings" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogActivity = false">取消</div>
                <div class="info-s" @click="submitActivity">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="生成二维码" :visible.sync="isQcode" width="518px" :append-to-body="true">
            <template>
                <div style="text-align: center;">
                    <img :src="qCode" style="width: 200px;height: 200px; display: block; margin: 0 auto;" />
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-s"><a :href="qCode" style="color:white;text-decoration: none;">导出</a>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import uploadPicture from '@/components/upload/mallPicture1.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
        uploadPicture
    },
    data() {
        return {
            isQcode: false,
            qCode: '',
            statusTitle: '禁用信息',
            isS: false,
            radio: '1',
            optionsActivity: '新增标签',
            form: {
                id: '',
                name: '',
                orderType: '',
                image: '',
                tag: [],
                tagStore: [],
                tagMarketing: []
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ],
                orderType: [
                    { required: true, message: '请输入订单类型', trigger: 'blur' },
                ],
                image: [
                    { required: true, message: '请上传页面图', trigger: 'change' },
                ],

            },
            goodsList: [

            ],
            dialogActivity: false,
            isS: false,
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '营销活动', path: '', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '营销活动', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                name: '',
                status: '',
                createdTimeStart: "",
                createdTimeEnd: '',
                updatedTimeStart: '',
                updatedTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            value1: [],
            value2: [],
            brandList: [],
            columns: [
                { label: '活动名称', prop: 'name', minWidth: '120' },
                { label: '订单类型', prop: 'orderTypeLabel', minWidth: '120' },

                {
                    label: '页面图', prop: 'image', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                            </div>
                        )
                    }
                },
                { label: '创建时间', prop: 'createdTime', minWidth: '100' },
                { label: '最近编辑时间', prop: 'updatedTime', minWidth: '100' },
                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusL == '启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },

                {
                    label: '操作',
                    minWidth: '150',
                    fixed: 'right',
                    // <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.lookQCode(scope.row.qrInfo, scope.row.qrInfoDown) }}>生成二维码</span>
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.copyLink(scope.row) }}>生成链接</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.lookQCode(scope.row.id) }}>生成二维码</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.updateStatus(scope.row) }}>{scope.row.statusLabel}</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row.id) }}>编辑活动</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.optionSetting('edit', scope.row.id) }}>页面装修</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.optionsRoute(scope.row.id) }}>编辑商品</span>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteD(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            goodsSearch: {
                tagId: '',
                pageNo: 1,
                pageSize: 10,
            },
            exporting: false,
            sName: '启用',
            isStatus: '',
            tagId: null,
            isD: false,
            aId: '',
            uStatus: '1',
            dId: '',
            tagIds: [],
            tagIds1: [],
            tagIds2: [],
            tagIdsShow: [],
            tagIdsShow1: [],
            tagIdsShow2: [],
            tagMarketings: [],
            tagMarketingsT: [],
            tag: [],
            tagStore: [],
            tagMarketing: [],
        }
    },
    created() {
        // this.getPageList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addTag') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        copyLink(item) {
            const t = this
            // let webSite
            // if (process.env.NODE_ENV === 'prod') {
            //     webSite = 'https://app.jiuhangyunxuan.com/'
            // } else {
            //     webSite = 'https://testapp.jiuhangyunxuan.com/'
            // }
            let url = `pagesGoods/marketing/marketing?id=${item.id}`
            this.axios.post('/wx/generateShortLink', {
                pageUrl: url,
            }).then(res => {
                if (res.code == 0) {
                    this.$copyText(res.data).then(
                        function (e) {
                            t.$message({
                                type: 'success',
                                message: '生成成功'
                            })
                        },
                        function (e) {
                            t.$message({
                                type: 'warning',
                                message: '生成失败'
                            })
                        }
                    )
                }
            })

        },
        lookQCode(id) {
            const t = this
            // let webSite
            // if (process.env.NODE_ENV === 'prod') {
            //     webSite = 'https://app.jiuhangyunxuan.com/'
            // } else {
            //     webSite = 'https://testapp.jiuhangyunxuan.com/'
            // }
            let url = `pagesGoods/marketing/marketing`
            this.axios.post('/wx/generateQrCode', {
                pageUrl: url,
                scene: '?id=' + id
            }).then(res => {
                if (res.code == 0) {
                    this.isQcode = true
                    this.qCode = res.data
                }
            })
        },
        getDataTag() {
            let tempArr = []
            this.tagIds1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            let tempArr1 = []
            this.tagIds2.forEach(item => {
                this.tag.forEach(itm => {
                    if (itm == item.id) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1,
                            pid: item.pid,
                            childTags: []
                        }

                        tempArr1.push(obj)
                    }
                })

            })
            console.log(tempArr1)
            tempArr.forEach(item => {
                tempArr1.forEach(itm => {
                    if (itm.pid == item.id) {
                        item.childTags.push(itm)
                    }
                })

            })
            this.form.tag = tempArr
        },
        getDataSTag() {
            let tempArr = []
            this.tagIdsShow1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            let tempArr1 = []
            this.tagIdsShow2.forEach(item => {
                this.tagStore.forEach(itm => {
                    if (itm == item.id) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1,
                            pid: item.pid,
                            childTags: []
                        }

                        tempArr1.push(obj)
                    }
                })

            })
            console.log(tempArr1)
            tempArr.forEach(item => {
                tempArr1.forEach(itm => {
                    if (itm.pid == item.id) {
                        item.childTags.push(itm)
                    }
                })

            })
            this.form.tagStore = tempArr
        },
        submitActivity() {
            console.log(this.$refs["cascader"].getCheckedNodes(), this.tagIds1, this.tagIds2)
            this.getDataTag()
            this.getDataSTag()
            this.form.tagMarketing = []
            this.tagMarketings.forEach(item => {
                this.tagMarketing.forEach(itm => {
                    if (item.id == itm) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1
                        }
                        this.form.tagMarketing.push(obj)
                    }
                })
            })
            console.log(this.form.tag)
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.axios.post('/marketActivate/addEdit', this.form)
                        .then(res => {
                            if (res.code == 0) {
                                if (this.optionsActivity == '新增活动') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                this.dialogActivity = false
                                this.getPageList()
                            }

                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getImage(val) {
            this.form.image = val
            this.$refs['form'].clearValidate('image')
        },
        getmTagList() {
            this.tagMarketingsT = []
            this.tagMarketing = []
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/marketing/pageList', data)
                .then(res => {
                    this.tagMarketings = res.data.list;
                })
            console.log(this.tagMarketings)
        },
        getTagList() {
            this.tagIds = []
            this.axios.post('/tagPool/filter/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIds.push(obj)
                    })
                    this.getSecondTag()
                })
        },
        getSecondTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/filter/pageList', data)
                .then(res => {
                    this.tagIds2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIds.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIds1 = this.tagIds
                })
        },
        getsTagList() {
            this.tagIdsShow = []
            this.axios.post('/tagPool/show/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIdsShow.push(obj)
                    })
                    this.getSecondsTag()
                })
        },
        getSecondsTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000,
            }
            this.axios.post('/tagPool/show/pageList', data)
                .then(res => {
                    this.tagIdsShow2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIdsShow.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIdsShow1 = this.tagIdsShow
                })
        },
        submitA() {
            let data = {
                id: this.aId,
                status: this.uStatus
            }
            this.axios.post('/marketActivate/disable', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.getPageList()
                        this.isS = false
                    }
                })
        },
        submitD() {
            let data = {
                id: this.dId,
            }
            this.axios.post('/marketActivate/delete', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.getPageList()
                        this.isD = false
                    }
                })
        },
        optionSetting(type, id) {
            this.$router.push({
                name: 'settingPage',
                query: {
                    id: id,
                    type: type,
                }
            })
        },
        options(type, id) {
            this.$router.push({
                name: 'settingActivity',
                query: {
                    id: id,
                    type: type,
                }
            })
            return
            // this.getTagList()
            // this.getsTagList()
            // this.getmTagList()
            if (this.$refs['form']) {
                this.$refs['form'].clearValidate()
            }
            if (type == 'add') {
                this.getTagList()
                this.getsTagList()
                this.getmTagList()
                this.optionsActivity = '新增活动'
                this.form.name = ''
                this.form.orderType = ''
                this.form.image = ''
                this.tag = []
                this.tagStore = []
                this.tagMarketing = []
                this.dialogActivity = true
                this.form.id = ''
            } else {
                this.optionsActivity = '编辑活动'
                this.tag = []
                this.tagStore = []
                this.tagMarketing = []
                this.getDetail(id)
            }
            this.$forceUpdate()
            // this.dialogActivity = true
        },
        async getDetail(id) {
            this.$nextTick(() => {
                this.axios.post('/marketActivate/detail', { id: id })
                    .then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            this.getTagList()
                            this.getsTagList()
                            this.getmTagList()
                            res.data.tag.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tag.push(String(itm.id))
                                        }

                                    })

                                }
                            })

                            res.data.tagStore.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tagStore.push(String(itm.id))
                                            console.log(this.tagStore)
                                        }

                                    })

                                }
                            })
                            res.data.tagMarketing.forEach(item => {
                                if (item.selected == 1) {
                                    this.tagMarketing.push(item.id)
                                }
                            })
                            this.form = res.data

                            this.dialogActivity = true
                        }

                    })
                this.$forceUpdate()
            })

        },
        getVdata(id) {
            return new Promise((resolve, reject) => {
                this.axios.post('/marketActivate/detail', { id: id })
                    .then(res => {
                        console.log(res)
                        if (res.code == 0) {

                            res.data.tag.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tag.push(String(itm.id))
                                        }

                                    })

                                }
                            })
                            let data = {
                                tag: this.tag,
                            }
                            console.log(data)
                            resolve(data)
                            res.data.tagStore.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tagStore.push(String(itm.id))
                                            console.log(this.tagStore)
                                        }

                                    })

                                }
                            })
                            res.data.tagMarketing.forEach(item => {
                                if (item.selected == 1) {
                                    this.tagMarketing.push(item.id)
                                }
                            })
                            this.form = res.data
                        }

                    })

            })

        },
        deleteD(id) {
            this.isD = true
            this.dId = id
            // let msg = '是否确认删除该商品？'
            // this.$confirm(msg, '温馨信息', {
            //     title: '温馨信息',
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.axios.post('/tags/deleteTagGood', { id: id })
            //         .then(res => {
            //             console.log(res)
            //             if (res.code == 0) {
            //                 this.$message.success('删除成功')
            //                 this.getShopList()
            //                 this.getPageList()
            //             }
            //         })
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消'
            //     })
            // })
        },
        add(val) {
            this.$router.push({
                name: 'addTag',
                query: {
                    id: val
                }
            })
        },
        optionsRoute(id) {
            this.$router.push({
                name: 'marketActivityDetail',
                query: {
                    id: id
                }
            })
        },
        getShopList() {
            this.goodsSearch.pageNo = this.page1.pageNo
            this.goodsSearch.pageSize = this.page1.pageSize
            this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
                .then(res => {
                    console.log(res)
                    this.goodsList = res.data.list;
                    this.page1.totalNum = res.data.totalNum;

                })
        },
        look(id) {
            this.dialogGoods = true
            this.goodsSearch.tagId = id
            this.getShopList()
        },
        isStart(val) {
            this.isS = true
            this.sName = val.statusL
            this.tagId = val.id
            if (val.statusL == '启用') {
                this.isStatus = true
            } else {
                this.isStatus = false
            }

        },
        updateStatus(row) {
            this.isS = true
            this.aId = row.id
            if (row.status == 1) {
                this.uStatus = 2
            } else {
                this.uStatus = 1
            }

            // let data = {
            //     id: this.tagId,
            //     status: this.isStatus,
            // }
            // this.axios.post('/tags/updateStatus', data)
            //     .then(res => {
            //         console.log(res)
            //         if (res.code == 0) {
            //             this.$message.success('操作成功')
            //             this.isS = false
            //             this.getPageList()
            //         }

            //     })
        },
        exportFn() {
            this.exporting = true
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.joinTimeStart = this.value1[0];
                this.searchForm.joinTimeEnd = this.value1[1];
            } else {
                this.searchForm.joinTimeStart = ''
                this.searchForm.joinTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.axios.post('/users/exportList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code === 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.value2 = []
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
            }
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            if (this.value2 && this.value2.length > 0) {
                this.searchForm.updatedTimeStart = this.value2[0];
                this.searchForm.updatedTimeEnd = this.value2[1];
            } else {
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            if (this.value2 && this.value2.length > 0) {
                this.searchForm.updatedTimeStart = this.value2[0];
                this.searchForm.updatedTimeEnd = this.value2[1];
            } else {
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/marketActivate/pageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        if (item.status == 1) {
                            item.statusL = '启用'
                            item.statusLabel = '禁用'
                        } else {
                            item.statusL = '禁用'
                            item.statusLabel = '启用'
                        }
                        item.mainImageArr = []
                        item.mainImageArr.push(item.image)
                    })
                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) { },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        handleSizeChange1(e) {
            this.page1.pageSize = e;
            this.page1.pageNo = 1;
            this.getShopList()
        },
        handleCurrentChange1(e) {
            this.page1.pageNo = e;
            this.getShopList()
        },
        todetail(row) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: row.id
                }
            })
        }
    }
}
</script>
<style lang="scss">
.optionC {
    .el-cascader-panel {
        .el-scrollbar:first-child {
            .el-checkbox {
                display: none;
            }
        }
    }
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    font-weight: 700;
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
    color: #2d46ee;
    font-weight: 700;
}
</style>
<style scoped lang="scss">
.p-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909099;
    margin-bottom: 18px
}

.start {
    width: 10px;
    height: 10px;
    background: #13ce4b;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.end {
    width: 10px;
    height: 10px;
    background: #f63c56;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

/deep/ .el-dialog {
    // display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);

    .el-dialog__body {
        padding: 30px 25px;
        padding-top: 10px !important;
        // height: 800px;
        flex: 1;
        overflow: auto;
    }
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  